import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <p className="text-primary text-5xl font-bold">404</p>
      <h1 className="text-lg font-semibold">Sayfa bulunamadı</h1>
      <p className="text-muted-foreground max-w-sm text-sm">
        Aradığınız sayfa taşınmış veya hiç var olmamış olabilir.
      </p>
      <Link to="/">
        <Button variant="outline" size="sm">
          Gösterge paneline dön
        </Button>
      </Link>
    </div>
  );
}